export default "__VITE_ASSET__CQwyN31P__"